import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FormActions = ({ 
  isFormValid, 
  isSubmitting, 
  onSubmit, 
  onReset,
  showReset = true 
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/');
  };

  const handleSubmit = () => {
    if (isFormValid && !isSubmitting) {
      onSubmit();
    }
  };

  return (
    <div className="space-y-4">
      {/* Primary Actions */}
      <div className="flex flex-col sm:flex-row gap-3">
        {/* Continue Button */}
        <Button
          variant="primary"
          size="lg"
          fullWidth
          disabled={!isFormValid || isSubmitting}
          loading={isSubmitting}
          onClick={handleSubmit}
          iconName="ArrowRight"
          iconPosition="right"
          className="order-2 sm:order-1"
        >
          {isSubmitting ? 'Traitement en cours...' : 'Continuer'}
        </Button>
      </div>

      {/* Secondary Actions */}
      {showReset && (
        <div className="flex justify-center">
          <Button
            variant="ghost"
            size="sm"
            onClick={onReset}
            disabled={isSubmitting}
            iconName="RotateCcw"
            iconPosition="left"
          >
            Réinitialiser le formulaire
          </Button>
        </div>
      )}

      {/* Form Status Indicators */}
      <div className="flex items-center justify-center space-x-4 text-xs text-text-secondary font-inter">
        {/* Required Fields Indicator */}
        <div className="flex items-center space-x-1">
          <Icon name="AlertCircle" size={12} />
          <span>* Champs obligatoires</span>
        </div>

        {/* Security Indicator */}
        <div className="flex items-center space-x-1">
          <Icon name="Lock" size={12} color="var(--color-success)" />
          <span>Connexion sécurisée</span>
        </div>
      </div>

      {/* Progress Indicator */}
      <div className="text-center">
        <div className="inline-flex items-center space-x-2 px-3 py-1 bg-primary-50 rounded-full">
          <Icon name="Clock" size={14} color="var(--color-primary)" />
          <span className="text-xs font-medium text-primary font-inter">
            Étape 1 sur 2 - Temps estimé : 2 minutes
          </span>
        </div>
      </div>
    </div>
  );
};

export default FormActions;